import React from "react";
import { Button, Dialog, Link } from "@sscs/ui";
import { FILESTREAM_PURL, FILESTREAM_ROUTE, PROJECTS_ROUTE } from "Constants";
import { useReports } from "Hooks";

type ReportDeletedDialogProps = {
  isOpen: boolean;
  isFileStreamReport: boolean;
  onReturn: () => void;
};

const ReportDeletedDialog = ({
  isOpen,
  isFileStreamReport,
  onReturn,
}: ReportDeletedDialogProps): React.JSX.Element => (
  <Dialog.Frame size="xs" isOpen={isOpen}>
    <Dialog.Header>
      <Dialog.Header.Title>Report deleted</Dialog.Header.Title>
    </Dialog.Header>
    <Dialog.Body>
      <Dialog.Section>
        <Dialog.Section.Content>
          <span>This report has been deleted by another user.</span>
        </Dialog.Section.Content>
      </Dialog.Section>
    </Dialog.Body>
    <Dialog.Footer>
      <Dialog.Footer.Actions>
        <Link
          to={
            isFileStreamReport ? `/${FILESTREAM_ROUTE}` : `/${PROJECTS_ROUTE}`
          }
          onClick={onReturn}
          underline="none"
        >
          <Button>
            Return to {isFileStreamReport ? "file stream" : "projects"}
          </Button>
        </Link>
      </Dialog.Footer.Actions>
    </Dialog.Footer>
  </Dialog.Frame>
);

const ReportDeleted = (): React.JSX.Element => {
  const { openedReportKey, deletedReports, closeReport } = useReports();

  return (
    <ReportDeletedDialog
      isOpen={
        openedReportKey ? deletedReports.includes(openedReportKey) : false
      }
      isFileStreamReport={Boolean(
        openedReportKey?.includes(FILESTREAM_PURL.projectName),
      )}
      onReturn={() => {
        if (openedReportKey) closeReport(openedReportKey);
      }}
    />
  );
};

export default ReportDeleted;
